import { Dialog } from "primereact/dialog";
import es_ES from '@react-pdf-viewer/locales/lib/es_ES.json';
import { Button } from "primereact/button";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './estilo.css';
import AdjuntoService from "../service/AdjuntoService";

const es_ES_custom = {
    ...es_ES,
    // Traducciones adicionales o faltantes
    scrollMode: {
        ...es_ES.scrollMode, // Mantiene lo existente
        pageScrolling: 'Desplazamiento de página',
        continuous: 'Desplazamiento continuo',
        singlePage: 'Una página',
        dualPage: 'Dos páginas',
        dualPageCover: 'Dos páginas con portada',
    },
};

export const VisorPdf = ({ visible, onHide, fileBlobUrl, fileName, firmar, firmarEnviar, id, tipo, urls, toast }) => {

    const adjuntoSrv = new AdjuntoService();

    const subirFormularioPrincipal = async () => {
        if (!fileBlobUrl) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No hay archivo para subir.', life: 3000 });
            return;
        }

        try {
            const response = await fetch(fileBlobUrl);
            const blob = await response.blob();

            const formData = new FormData();
            const archivo = new File([blob], fileName, { type: blob.type });

            formData.append('file', archivo);
            formData.append('tipo', tipo);
            formData.append('descripcion', 'Formulario principal');
            formData.append('id', id);
            formData.append('lista', -1); // Valor especial que buscará el anexo con nombre 'Formulario principal'

            adjuntoSrv.newAdjunto(formData, urls.urlUpload).then(res => {
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Formulario principal subido correctamente', life: 3000 });
            }).catch(error => {
                toast.current.show({ severity: 'error', summary: error, detail: 'No se pudo subir el archivo.', life: 3000 });
            });
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar el archivo.', life: 3000 });
        }
    };

    const renderToolbar = (Toolbar) => (
        <Toolbar>
            {(slots) => {
                const {
                    CurrentPageInput,
                    Open,
                    Download,
                    EnterFullScreen,
                    GoToNextPage,
                    GoToPreviousPage,
                    NumberOfPages,
                    Print,
                    ShowSearchPopover,
                    Zoom,
                    ZoomIn,
                    ZoomOut,
                    ShowProperties,
                } = slots;

                return (
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            width: '100%',
                        }}
                    >
                        <div style={{ padding: '0px 2px' }}>
                            <ShowSearchPopover />
                        </div>
                        <div style={{ padding: '0px 2px' }}>
                            <GoToPreviousPage />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', padding: '0px 2px' }}>
                            {/* Custom CurrentPageInput with fixed width */}
                            <CurrentPageInput>
                                {(props) => (
                                    <input
                                        {...props}
                                        style={{
                                            width: '40px',
                                            textAlign: 'center',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            padding: '4px',
                                        }}
                                    />
                                )}
                            </CurrentPageInput>
                            <span style={{ margin: '0 4px' }}>/</span>
                            <NumberOfPages />
                        </div>
                        <div style={{ padding: '0px 2px' }}>
                            <GoToNextPage />
                        </div>
                        <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                            <ZoomOut />
                        </div>
                        <div style={{ padding: '0px 2px' }}>
                            <Zoom />
                        </div>
                        <div style={{ padding: '0px 2px', marginRight: 'auto' }}>
                            <ZoomIn />
                        </div>
                        <div style={{ padding: '0px 2px' }}>
                            <Button
                                tooltip="Firmar"
                                tooltipOptions={{
                                    position: "bottom",
                                    className: "tooltip-viewer"
                                }}
                                icon={'pi pi-file-edit'}
                                label=""
                                onClick={() => firmar()}
                                className="menu-button-viewer"
                            />
                        </div>
                        {/* <div style={{ padding: '0px 2px' }}>
                            <Button
                                tooltip="Firmar y Subir Formulario"
                                tooltipOptions={{
                                    position: "bottom",
                                    className: "tooltip-viewer"
                                }}
                                icon={'pi pi-send'}
                                label=""
                                onClick={firmarEnviar}
                                className="menu-button-viewer"
                            />
                        </div> */}
                        <div style={{ padding: '0px 2px' }}>
                            <Button
                                tooltip="Subir Formulario Principal"
                                tooltipOptions={{
                                    position: "bottom",
                                    className: "tooltip-viewer"
                                }}
                                icon={'pi pi-upload'}
                                label=""
                                onClick={subirFormularioPrincipal}
                                className="menu-button-viewer"
                            />
                        </div>
                        <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                            <EnterFullScreen />
                        </div>
                        <div style={{ padding: '0px 2px' }}>
                            <a
                                href={fileBlobUrl}
                                download={fileName}
                                style={{
                                    textDecoration: 'none',
                                    display: 'inline-flex',
                                    alignItems: 'center'
                                }}
                            >
                                <Button
                                    tooltip="Descargar"
                                    tooltipOptions={{
                                        position: "bottom",
                                        className: "tooltip-viewer"
                                    }}
                                    icon={'pi pi-download'}
                                    label=""
                                    className="menu-button-viewer"
                                />
                            </a>
                        </div>
                        {/* <div style={{ padding: '0px 2px' }}>
                            <Open />
                        </div> */}
                        <div style={{ padding: '0px 2px' }}>
                            <Print />
                        </div>
                        {/* <div style={{ padding: '0px 2px' }}>
                            <ShowProperties />
                        </div> */}
                    </div>
                );
            }}
        </Toolbar>
    );

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar,
        sidebarTabs: (defaultTabs) => [
            defaultTabs[0], // Tab de Miniatura
        ],
    });

    return (
        <Dialog
            header="Visualizar formulario"
            visible={visible}
            onHide={onHide}
            style={{ width: '80vw' }}
            maximizable
            modal
        >
            {/* 76vh Numero estándar para que funcionen los botones */}
            <div style={{ height: '76vh' }}>
                {fileBlobUrl && (
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                        <Viewer
                            fileUrl={fileBlobUrl}
                            plugins={[defaultLayoutPluginInstance]}
                            localization={es_ES_custom}
                        />
                    </Worker>
                )}
            </div>
        </Dialog>
    );
}
